import { IPage } from '../../interfaces';

export const mainPages: IPage[] = [
    // ------------------------------------------------------------
];
